import React,{useState,useCallback} from 'react'
import {Row,Col} from 'react-bootstrap'
import ZegarOdliczanie from "../Komponenty/zegar"
import { useOdliczanie } from '../Zegar/odliczanie'
import { useDispatch} from 'react-redux'
import { modOpcje } from '../Magazyn/kreatorAkcji'
import dayjs from 'dayjs'

const KonkursAktywny  = (props) => {
   const [kon_czas,setCzas] = useState(false)
   let test = props.konkurs.status_konkursu
   const dataTestu = dayjs(props.konkurs.data_testu*1000).format('YYYY-MM-DD')
   const czasTestu = dayjs(dataTestu+' '+props.konkurs.czas).unix()
   const nowData = dayjs(Date.now()).unix()
   const dataKonkurs = dayjs(czasTestu*1000).format('YYYY-MM-DD HH:mm:ss')
   const czas =  24  * 60 * 60 * 1000
   const [dni,godziny,minuty,sekundy] = useOdliczanie(dataKonkurs,czas)
   const dispach = useDispatch()
   if (sekundy < 0) {test = 'N'}

   const wybor = (event) => {
    const id  = event.target.id
    const data_T = event.target.children[0].value
    const obj = {id_konkursu : id,data_testu: data_T,czasTestu : czasTestu}
    dispach(modOpcje(obj))
    if (czasTestu > nowData) {props.funkcjaWidok('D')}else {props.funkcjaWidok('L')}
   }
 const wynik = (event) => {
    let id  = event.target.id
    let obj = {id_konkursu : id}
    dispach(modOpcje(obj))
    props.funkcjaWidok('W')
   }
   const koniec_czasu = useCallback(() => {
    setCzas(!kon_czas)
   },[kon_czas])

        return( 
          <div>  
                <Row className="konkurs_aktywny">
                  <Col xs={5}>
                        <Row>
                 <Col xs={3} className="wyroznienie_opis">Ogłoszenie o nr</Col>
                 <Col xs={3} className="wyroznienie_opis">Z dnia</Col>
                 <Col xs={3} className="wyroznienie_opis">Stanowisko</Col>
                 <Col xs={3} className="wyroznienie_opis">Jednostka</Col>
                   </Row>
                   <Row>
                 <Col xs={3}><span className="wyroznienie">{props.konkurs.nr_ogloszenia}</span></Col>
                 <Col xs={3}><span className="wyroznienie">{dayjs(props.konkurs.data_konkurs*1000).format('YYYY-MM-DD')}</span></Col>
                 <Col xs={3}><span className="wyroznienie">{props.konkurs.nazwa_stanowiska}</span></Col>
                 <Col xs={3}><span className="wyroznienie">{props.konkurs.jednostka}</span></Col> 
                   </Row>
                 </Col>
                 <Col xs={5}><ZegarOdliczanie dni={dni} godziny={godziny} minuty={minuty} sekundy={sekundy} funk={koniec_czasu}/></Col>
                 {test === 'A'  ? 
                    <Col xs={2} className="srodek"><button className='btn btn-danger btn-lg' id={props.konkurs.id_konkursu} onClick={wybor}>
                    <input type="hidden" id="data_testu" value ={props.konkurs.data_testu}/>Wybór</button></Col> : 
                  <Col xs={2} className="srodek"><button className='btn btn-primary btn-ms' id={props.konkurs.id_konkursu}  onClick={wynik}>Wynik</button></Col>}
                </Row>
              </div>
        )
}

export default KonkursAktywny